import React from 'react';
import PropTypes from 'prop-types';
// import { Alert } from 'antd';
import { colors, spacing } from '../lib/theme';
import AppAlertDiv from './Common/AppAlertDiv';

export default function UnsignedInfo({ message = 'All your progess will be saved when you sign in and also synced across all your devices for free.' }) {
    return (
        <div>
            {/* <Alert className='alert' message={message} type="info" showIcon /> */}
            <AppAlertDiv message={message} showIcon />
            <style jsx>
                {`
                :global(.alert) {
                    background: ${colors.primaryDim};
                    border: 1px solid ${colors.primary};
                    margin: ${spacing('md')} 0;
                }
            `}
            </style>
        </div>
    )
}
UnsignedInfo.propTypes = {
    message: PropTypes.string,
}
